import { Routine } from 'redux-saga-routines';
import { filter, map } from 'ramda';
import {
  fetchTeamsRoutine,
  createTeamRoutine,
  updateTeamRoutine,
  deleteTeamRoutine,
  getTeamUsersCountRoutine
} from './routines';
import { IUserInitials } from '../../common/models/user/IUserInitials';
import { ITeam } from '../../common/models/team/ITeam';

export type TeamsListState = {
  teams: ITeam[] | null;
  users: IUserInitials[] | null;
  loading: boolean;
  saving: boolean;
  deletable: boolean;
};

const initialState = {
  teams: null,
  users: null,
  loading: true,
  saving: false,
  deletable: false
};

export const teamList = (state: TeamsListState = initialState, { type, payload }: Routine<any>): TeamsListState => {
  switch (type) {
    case fetchTeamsRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchTeamsRoutine.SUCCESS:
      return {
        ...initialState,
        teams: payload.teams,
        users: payload.users,
        loading: false
      };
    case fetchTeamsRoutine.FAILURE:
      return initialState;
    case createTeamRoutine.SUCCESS:
      return {
        ...state,
        teams: [...(state.teams as ITeam[]), payload],
        saving: false
      };
    case updateTeamRoutine.TRIGGER:
    case createTeamRoutine.TRIGGER:
    case deleteTeamRoutine.TRIGGER:
      return {
        ...state,
        saving: true
      };
    case updateTeamRoutine.SUCCESS:
      return {
        ...state,
        saving: false,
        teams: map(
          team => (team.id === payload.id ? ({ ...team, ...payload }) : team),
          state.teams as ITeam[]
        )
      };
    case deleteTeamRoutine.SUCCESS:
      return {
        ...state,
        teams: filter(({ id }) => id !== payload, state.teams as ITeam[]),
        saving: false
      };
    case getTeamUsersCountRoutine.TRIGGER:
      return {
        ...state,
        deletable: false
      };
    case getTeamUsersCountRoutine.SUCCESS:
      return {
        ...state,
        deletable: !payload
      };
    default:
      return state;
  }
};
